"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const building_blocks_ui_theme_1 = require("@acko-tech/building-blocks.ui.theme");
const react_1 = __importDefault(require("react"));
const input_styles_1 = require("../input.styles");
const Radio = (props) => {
    const { dimension = "small", checked, onChange = () => { } } = props;
    const { theme } = (0, building_blocks_ui_theme_1.useTheme)();
    const colors = (0, building_blocks_ui_theme_1.useColor)();
    return (react_1.default.createElement(input_styles_1.CheckBoxElement, { type: "radio", checked: checked, onClick: onChange, theme: theme, colors: colors, dimension: dimension }));
};
exports.default = Radio;
//# sourceMappingURL=radio.js.map